import {api} from "../http/apiClient"

const ApiFampe = () => {
  const getFampe = (cnpj) => {
    return api.get(`/plans/fampe/${cnpj}/`)
  }
  const setFampe = (data) => {
    return api.post(`/plans/fampe/`, data)
  }
  const getCallMiddleware = () => {
    return api.get(`plans/fampe/call-middleware/`)
  }

  return { getFampe, setFampe, getCallMiddleware }
}

export default ApiFampe